module.exports = __webpack_public_path__ + "static/img/travelAppointment1.601c37d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelAppointment1.jpg
// module id = Gx1D
// module chunks = 0